import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { S3BudgetService } from 'src/app/Services/s3Budget.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { StorageService } from '../../Services/storage.service';
import { ApiService } from "./../../Services/api.service";//'src/app/Services/api.service';
import { KDTreeService } from './../../Services/kdtree.service';
import { LoaderService } from './../../Services/loader.service';
import { MapService } from './../../Services/map.service';
import { AlertData, cabData, DriverData, UserData, vehicleData, VendorData } from './alert.data';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import 'src/assets/map-assets/markerClusterer';
import { CommonServices } from 'src/app/Services/common.service';
import { SharedService } from 'src/app/Services/shared.service';
declare var MarkerClusterer: any;
declare var google: any;
declare const mapUtilityMapBox;
declare const $;
const call_Icon = `<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" x="0" y="0" version="1.1" viewBox="0 0 29 29" xml:space="preserve" width="288" height="288"><path d="M20.914 17.743l-2.091 1.178a1.319 1.319 0 0 1-1.58-.217l-6.979-6.979a1.32 1.32 0 0 1-.217-1.58l1.178-2.091a1.978 1.978 0 0 0-.325-2.37L7.766 2.55a1.978 1.978 0 0 0-2.798 0L3.545 3.972a5.276 5.276 0 0 0-.793 6.446l.714 1.19a41.36 41.36 0 0 0 14.946 14.631l.141.081c2.102 1.201 4.699.851 6.382-.831l1.486-1.486a1.978 1.978 0 0 0 0-2.798l-3.136-3.136a1.978 1.978 0 0 0-2.371-.326z" fill="#6364af" class="color000 svgShape"/><path fill="none" stroke="#377918" stroke-miterlimit="10" stroke-width="2" d="M22.018 6.982l-6 6M18.018 6.482h4.5v4.5" class="colorStroke000 svgStroke"/></svg>`;

@Component({
  selector: 'app-sosalert',
  templateUrl: './sosalert.component.html',
  styleUrls: ['./sosalert.component.css']
})
export class SOSalertComponent implements OnInit {
  isShowNearby = false;
  audioisShow = false;
  isShowEmployee = false;
  isShowVehicle = false;
  public isShowClickToCall: boolean = false;
  public callConnectingDot: boolean = false;
  public connectedCallList: any = {}; // Employee or Driver IDs

  date = new Date();
  height: any = '380px';

  public mapHight = '82.5vh';
  public notificationHeight = '75.85vh';

  public nearByEmpMarkers = [];
  public nearByVehMarkers = [];

  notificationData: any = [];
  public noDataEnable: boolean = false;
  driverData: any = [];
  panelDriverInfo: any = {}; // driver info
  panelVehicleInfo: any = {};
  panelEmployeeInfo: any = {};
  panelVendorInfo: any = {};
  panelSosInfo: any = {};

  isShowCabData: any = false;
  isShowEmployeeData: any = false;
  public selectedNotificationDetails: any;
  public nearestEmployees: any = [];
  public nearestVehicles: any = [];
  public loggedInInfo: any;
  public driverLicence: any;
  public fileName: string;
  public nearByVehicles: any = {};
  public enableClick: boolean = false;
  public defaultImageUrl: string = `../../../assets/images/home/employee.png`;

  public locationRegExp = `,`;
  public locationReplaceStr = `, `;

  public closeTakeAction: boolean = true;
  public takeActionPopup: boolean = true;

  public vendorID = '';
  public orgID: string = '';
  public mapObj: any;
  public mapId = "EMPS_TM_sos_map";
  public map_marker_vehRegNo_style = 'hidden';

  //for map
  public selectedMap: string = 'osrm';
  // public selectedMap:string='google';
  public googleMapObj: any;
  public globalMarkers: any = [];
  public googleMapMarkers: any;
  public isGoogleLocMarked: boolean = false;
  public gglMapCluster: any;
  public singleViewCluster: any;
  public clusteringOptions = {
    styles: [{
      url: "assets/images/map/googleMap/m1.png",
      width: 53,
      height: 53,
      textSize: 12,
      textColor: "white",
    }],
    minimumClusterSize: 2,
    maxZoom: 14
  };

  public showNoEmp: boolean = false;
  public showNoVeh: boolean = false;
  constructor(
    private map: MapService,
    public storage: StorageService,
    private loader: LoaderService,
    private kdTree: KDTreeService,
    private api: ApiService,
    public route: ActivatedRoute,
    private store: StorageService,
    private file: FileUploadService,
    private swal: SweetAlert,
    private comService: CommonServices,
    private router: Router,
    iconRegistry: MatIconRegistry, sanitizer: DomSanitizer,
    private s3AudioService: S3BudgetService,
    private shared: SharedService,
  ) {
    // this.route.paramMap.subscribe((params: any) => {
    //   this.vendorID = params.params.vendorID;
    // });
    setTimeout(() => {
      this.loggedInInfo = this.store.get('userInfo');
      if (this.loggedInInfo && this.loggedInInfo.map) {
        this.selectedMap = this.loggedInInfo.map;
      }
      iconRegistry.addSvgIconLiteral('callIcon', sanitizer.bypassSecurityTrustHtml(call_Icon));
      this.initMap([]);
    }, 500);
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.getSOSReports();
    }, 500);
  }

  initMap(markers: any) {
    if (this.selectedMap == 'google') {
      setTimeout(() => {
        const mapOptions = {
          scrollwheel: true,
          zoom: 7,
          maxZoom: 22,
          center: new google.maps.LatLng(12.9716, 77.5946),
          fullscreenControl: false,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
          },
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_CENTER,
          },
          streetViewControl: false,
        };
        if (this.loggedInInfo.defaultLoc != undefined) {
          mapOptions.center = new google.maps.LatLng(this.loggedInInfo.defaultLoc.lat, this.loggedInInfo.defaultLoc.lng)
          mapOptions.zoom = 9;
        }
        this.googleMapObj = new google.maps.Map(document.getElementById('EMPS_TM_sos_map'), mapOptions);
      }, 10)

    } else {
      try {
        const mapBoxKey = 'pk.eyJ1Ijoib3dlbmxhbWIiLCJhIjoiY2lleWljcnF4MDBiOXQ0bHR0anRvamtucSJ9.t3YnHHqvQZ8Y0MTCNy0NNw';
        const parent = this;
        if (mapBoxKey) {
          const MyMap1 = new mapUtilityMapBox();
          MyMap1.setup('EMPS_TM_sos_map', {
            key: mapBoxKey
          },
            function (map) {
              parent.mapObj = map;
              map.clusters = [
                {
                  name: 'SOSAlertcluster',  // unique id
                  maxZoom: 14, // max zoom on cluster click event
                  radius: 20,
                  color: 'rgba(255, 0, 0, 0.2)', //'#be9694'  // for opacity use rgb 
                  textColor: 'black' // count color
                },
                {
                  name: 'SOSEmployeecluster',
                  maxZoom: 14,
                  radius: 20,
                  color: 'rgba(98, 100, 167, 0.5)', //#6264a7,
                  textColor: 'green'
                },
                {
                  name: 'SOSVehiclecluster',
                  maxZoom: 14,
                  radius: 20,
                  color: 'rgba(78, 124, 251, 0.5)',  //#4e7cfb,
                  textColor: 'green'
                },
              ];

              if (markers.length > 0) {

                map.addMarkers(markers);
                setTimeout(() => {
                  map.clusterSynch();
                }, 500);
              }

              map.onMapZoom((z) => {
                /* show vehicle Reg No when zoom level is above 13 */
                if (z >= 13) {
                  if (parent.map_marker_vehRegNo_style == 'hidden') {
                    const veh_Reg_nums = document.querySelectorAll('.map_marker_vehRegNo');
                    for (let i = 0; i < veh_Reg_nums.length; i++) {
                      const elem: any = veh_Reg_nums[i];
                      elem.style.visibility = 'visible';
                    }
                    parent.map_marker_vehRegNo_style = 'visible';
                  }
                }
                else {
                  if (parent.map_marker_vehRegNo_style == 'visible') {
                    const veh_Reg_nums = document.querySelectorAll('.map_marker_vehRegNo');
                    for (let i = 0; i < veh_Reg_nums.length; i++) {
                      const elem: any = veh_Reg_nums[i];
                      elem.style.visibility = 'hidden';
                    }
                    parent.map_marker_vehRegNo_style = 'hidden';
                  }
                }
                map.clusterSynch();
                setTimeout(() => {
                  map.marker(markers);
                }, 10);
              });

              map.onClick({
                type: 'marker',
              }, (e: any) => {
                map.focus({
                  lat: e._lngLat.lat,
                  lng: e._lngLat.lng,
                  zoom: 18
                });
              });
            });
        }

        if (this.mapObj) {
          this.enableClick = true;
        }

      } catch (error) {
        console.log(error);
      }
    }
  }

  connectCall(receiver, id) {
    if (id && this.loggedInInfo && this.loggedInInfo.userID && !(this.connectedCallList && this.connectedCallList[receiver] && this.connectedCallList[receiver][id])) {

      let obj = {
        makecall: [`${this.loggedInInfo.userID}#$O`],
      };

      switch (receiver) {
        case 'Driver':
          obj.makecall[1] = `${id}#$D`;
          break;
        case 'Employee':
          obj.makecall[1] = `${id}#$E`;
          break;
        case 'Vendor':
          obj.makecall[1] = `${id}#$V`;
          break;
        default: break;
      }
      this.api.sosClickToCall(obj).then((res: any) => {
        if (res.status == 'success') {

          if (this.connectedCallList[receiver] == undefined) this.connectedCallList[receiver] = {};
          if (this.connectedCallList[receiver][id] == undefined) this.connectedCallList[receiver][id] = {};

          this.connectedCallList[receiver][id] = true;

          setTimeout(() => {
            this.connectedCallList[receiver][id] = false;
          }, 60000)

          // this.swal.swalFunction(res.status, res.status, res.message, 2000);
        } else {
          this.swal.swalFunction('error', res.status, res.message, 2000);
        }

      }).catch((err) => {
        console.log(err);
      });

    }

  }

  getSOSReports() {
    this.notificationData = [];
    this.api.getSOSLists({}).then((res: any) => {
      if (res.status == 'success') {
        res.data.map(async (item) => {
          let obj = { ...item };
          if (obj['sosAudio'] && obj['sosAudio'].length > 0) {
            for (let i = 0; i < obj['sosAudio'].length; i++) {
              let resultAudio = await this.s3AudioService.s3GetAudio(obj['sosAudio'][i]);
              obj['sosAudio'][i] = resultAudio;
            }
          }
          this.notificationData.push(obj);
          // this.filterData(this.notificationData);
        })
        setTimeout(() => {
          this.setMarkers();
          let sosID = this.storage.get('sosID');
          if (sosID != '' && sosID != undefined && sosID != null) {
            let data = this.notificationData.filter(e => e.sosID == sosID)
            this.storage.remove('sosID');
            this.notifiyData(data[0])
          }
          this.shared._subject.subscribe((data: any) => {
            if (data && data.type && data.type == 'sosID') {
              let filData = this.notificationData.filter(e => e.sosID == data.data);
              this.notifiyData(filData[0])
            }
          })
          this.noDataEnable = true;
        }, 1500);
      }
      else this.noDataEnable = true;
    })
  }

  playAudioFile() {
    if (this.selectedNotificationDetails.sosAudio && this.selectedNotificationDetails.sosAudio.length > 0) {
      this.audioisShow = !this.audioisShow;
      setTimeout(() => { this.playMultiAudio(this.selectedNotificationDetails.sosAudio); }, 100);
    }
  }

  fetchResults(url) {
    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((myJson) => {
        // console.log("hi", myJson);
        // resolve(myJson);
      });
  }

  setMarkers() {
    if (this.globalMarkers && this.globalMarkers.length > 0) {
      for (let i = 0; i < this.globalMarkers.length; i++) {
        this.globalMarkers[i].setMap(null);
      }
    }
    this.globalMarkers = [];
    if (this.selectedMap == 'google') {
      if (this.notificationData.length > 0) {
        let loc;
        let image = {
          origin: new google.maps.Point(0, 0),
          scaledSize : new google.maps.Size(10,10),
        };
        let infoWindowContent;
        let infowindow;
        let filVal;
        for (let i = 0; i < this.notificationData.length; i++) {
          loc = {
            lat: this.notificationData[i]['lat'],
            lng: this.notificationData[i]['lng']
          }
          if (this.notificationData[i]['speed'] > 50) {
            image['url'] = "assets/images/map/googleMap/pickuppoint-purple.png";
          } else if (this.notificationData[i]['speed'] <= 5) {
            image['url'] = "assets/images/map/googleMap/pickuppoint-purple.png";
          } else if (this.notificationData[i]['speed'] > 5) {
            image['url'] = "assets/images/map/googleMap/pickuppoint-purple.png";
          } else {
            image['url'] = "assets/images/map/googleMap/pickuppoint-purple.png";
          }
          let marker = new google.maps.Marker({
            position: loc,
            icon: image
          })
          this.globalMarkers.push(marker);
          for (let j = 0; j < this.globalMarkers.length; j++) {
            this.globalMarkers[j].addListener('click', (e) => {
              this.googleMapObj.setZoom(15);
              this.googleMapObj.panTo(this.globalMarkers[j].position);
              filVal = this.notificationData.filter(obj => e.latLng.lat() == obj.lat && e.latLng.lng() == obj.lng);
              if (infowindow) infowindow.close();
              if (filVal.length > 0) {
                infoWindowContent = '<div class="window-content-container"><span style="font-weight:700">' + filVal[0].regNo + '</span><div style="margin-top:2px">' + 'Updated :' + '<span>' + ' ' + this.comService.timestampToDate(filVal[0].gpsTS,'DMY H:M:S')+ '</span></div><div style="margin-top:2px">' + 'Speed :' + ' ' + '<span>' + filVal[0].speed + ' ' + 'kmph' + '</span>' + '</div>' + '</div>';
                infowindow = new google.maps.InfoWindow({
                  content: infoWindowContent
                });
              }
            })
            google.maps.event.addListener(this.globalMarkers[j], 'click', function () {
              infowindow.open(this.googleMapObj, this);
            });
          }
        }
        this.gglMapCluster = new MarkerClusterer(
          this.googleMapObj, this.globalMarkers, this.clusteringOptions
        );
      }
    } else {
      if (this.mapObj) {
        this.mapObj.removeMarkerAll();
        if (this.notificationData.length > 0) {
          let markers = [];
          this.notificationData.filter((val, i) => {
            const marker = {
              id: val.sosID,
              content: `<div class="red-dot dot--basic"></div>
              <span class="mumb_marker_marker-label map_marker_vehRegNo">${val['regNo'].toUpperCase()}</span>`,
              lat: val.lat,
              lng: val.lng,
              cluster: 'SOSAlertcluster',
            };
            markers.push(marker);
          })
          this.mapObj.addMarkers(markers);
          this.mapObj.clusterSynch();
          setTimeout(() => {
            this.mapObj.focus({
              lat: markers[0].lat,
              lng: markers[0].lng,
              zoom: 10
            });
          }, 500);
        }
      }
    }

  }
  toDateFormat(value) {  
    if (!value) return '';
    let date: any = new Date(value);
    var Str = ("00" + (date.getDate() + 1)).slice(-2)
      + "/" + ("00" + date.getMonth()).slice(-2)
      + "/" + date.getFullYear() + " "
      + ("00" + date.getHours()).slice(-2) + ":"
      + ("00" + date.getMinutes()).slice(-2)
      + ":" + ("00" + date.getSeconds()).slice(-2);
    return Str;
  }
  employeeToCabs() {
    this.isShowEmployeeData = true;
    this.isShowCabData = false;
  }
  cabsToEmployee() {
    this.isShowCabData = true;
    this.isShowEmployeeData = false;
  }

  getSOSViewData(sosID) {
    return new Promise((resolve, rej) => {
      try {
        this.api.getSOSViewDataHl({ sosID }).then((res: any) => {
          if (res.status == 'success') {
            if (res.data) resolve(res.data);
            else resolve([]);
          }
          else resolve([]);
        })
        //  res()
      } catch (error) {
        rej([])
      }
    })
  }

  getNearestEmpVeh(location) {
    return new Promise((resolve, rej) => {
      try {
        let obj = {
          sosLocation: {
            lat: location.lat,
            lng: location.lng,
          }
        };
        this.api.sosNearByEmployeeHl(obj).then((res: any) => {
          if (res.status == 'success') {
            let employees = [];
            let vehicles = [];
            try {
              if (res.employee && res.employee.length > 0) {
                employees = res.employee;
              }
              if (res.vehicle && res.vehicle != 'Vehicle Not Available') {
                for (let i = 0; i < res.vehicle.length; i++) {
                  if (res.vehicle[i] && typeof res.vehicle[i] === 'string')
                    vehicles[i] = JSON.parse(res.vehicle[i]);
                  else vehicles[i] = res.vehicle[i];
                }
              }
            } catch (error) {
              console.log(error);
            }
            resolve([employees, vehicles]);
          }
        })
        //  res()
      } catch (error) {
        rej([])
      }
    })
  }

  async downloadDriverLicence(driver) {
    this.fileName = `${driver.name.replaceAll(' ', '_')}-licence.jpg`;
    this.driverLicence = await this.file.urlHandleBase64(driver.licence);
    setTimeout(() => {
      document.getElementById('downloadLicence').click();
    }, 200);
  }

  checkTimestamp(time) {
    let result: boolean = false;
    let less1Hr = new Date().setHours(new Date().getHours() - 2);
    let timestamp = new Date(less1Hr).getTime();
    if (time > timestamp) result = true;
    return result
  }

  async notifiyData(val) {
    await this.initMap([]);
    this.nearestVehicles = [];
    this.nearestEmployees = [];
    if (this.googleMapObj || this.mapObj) {
      this.isShowNearby = this.checkTimestamp(val.gpsTS);
      this.isShowClickToCall = this.checkTimestamp(val.gpsTS);
      this.audioisShow = false;
      this.loader.show();
      if (this.selectedMap != 'google') {
        if (this.mapObj) {
          this.mapObj.removeMarkerAll();
        }
      }
      this.selectedNotificationDetails = val;
      if ((val?.empID != undefined) && (val?.driverID != undefined)) {
        this.isShowVehicle = false;
        this.isShowEmployee = true;
      }
      if ((val?.empID == undefined) && (val?.driverID != undefined)) {
        this.isShowEmployee = false;
        this.isShowVehicle = true;
      }
      this.mapHight = '63vh';        // when bottom data showing map will be reduced.
      this.notificationHeight = '56.5vh';
      this.isShowEmployeeData = false;
      this.panelVendorInfo = {};
      this.panelDriverInfo = {};
      this.panelVehicleInfo = {};
      this.panelEmployeeInfo = {};
      this.panelSosInfo = {};
      let sosViewData: any = await this.getSOSViewData(val.sosID);
      if (sosViewData && sosViewData.length > 0) {
        try {
          this.panelVendorInfo = {
            name: sosViewData[0]['vendorName'],
            mobile: sosViewData[0]['vendorMob'],
            vendorID: sosViewData[0]['vendorID']
          };
          this.vendorID = sosViewData[0]['vendorID'];

          this.panelSosInfo = {
            location: sosViewData[0]['near'] ? sosViewData[0]['near'] : '---',
          }

          this.panelDriverInfo = {
            name: sosViewData[0]['driverName'],
            mobile: sosViewData[0]['driverMob'],
            driverID: sosViewData[0]['driverID']
          };
          this.panelVehicleInfo = {
            vehRegNo: sosViewData[0]['vehRegNo'],
            model: sosViewData[0]['model'],
            make: sosViewData[0]['make']
          };
          if (sosViewData[0]['empInfo']) {
            this.panelEmployeeInfo = {
              name: sosViewData[0]['empInfo'][0]['name'],
              empRefID: sosViewData[0]['empInfo'][0]['empRefID'],
              profile: sosViewData[0]['empInfo'][0]['profile'],
              mobile: sosViewData[0]['empInfo'][0]['mobile'],
              employeeID: sosViewData[0]['empInfo'][0]['employeeID'],
            };
          }
        } catch (err) {
          console.log('Sos Panel Error', err)
        }
      }
      let marker;
      if (this.selectedMap == 'google') {
        if (this.nearByEmpMarkers.length > 0) {
          for (let i = 0; i < this.nearByEmpMarkers.length; i++) {
            this.nearByEmpMarkers[i].setMap(null);
          }
        }
        for (let i = 0; i < this.globalMarkers.length; i++) {
          this.globalMarkers[i].setMap(null);
        }
        this.globalMarkers = [];
        if (this.gglMapCluster) {
          this.gglMapCluster.clearMarkers();
        }
        let loc = {
          lat: val.lat,
          lng: val.lng
        }
        let image = {
          scaledSize: new google.maps.Size(30, 30),
        };
        if (val['speed'] > 50) {
          image['url'] = "assets/images/map/googleMap/map_blue.png";
        } else if (val['speed'] <= 5) {
          image['url'] = "assets/images/map/googleMap/sos1.png";
        } else if (val['speed'] > 5) {
          image['url'] = "assets/images/map/googleMap/map_orange.png";
        } else {
          image['url'] = "assets/images/map/googleMap/map_orange.png";
        }
        this.globalMarkers.push(new google.maps.Marker({
          position: loc,
          map: this.googleMapObj,
          icon: image
        }));
        let infoWindowContent;
        let infowindow;
        for (let i = 0; i < this.globalMarkers.length; i++) {
          this.globalMarkers[i].addListener('click', (e) => {
            infoWindowContent = '<div class="window-content-container"><span style="font-weight:700">' + val.regNo + '</span><div style="margin-top:2px">' + 'Updated :' + '<span>' + ' ' +  this.comService.timestampToDate(val.gpsTS,'DMY H:M:S')+ '</span></div><div style="margin-top:2px">' + 'Speed :' + ' ' + '<span>' + val.speed + ' ' + 'kmph' + '</span>' + '</div>' + '</div>';
            infowindow = new google.maps.InfoWindow({
              content: infoWindowContent
            });
            this.googleMapObj.setZoom(15);
            this.googleMapObj.panTo(loc);
          })
          google.maps.event.addListener(this.globalMarkers[i], 'click', function () {
            infowindow.open(this.googleMapObj, this);
          });
        }
        this.googleMapObj.setZoom(10);
        this.googleMapObj.panTo(loc);
        marker = this.googleMapMarkers;
      } else {
        marker = [
          {
            id: val.regNo,
            content: `<div class="red-dot dot--basic"></div>
                    <span class="mumb_marker_marker-label" style="visibility:visible">${val['regNo'].toUpperCase()}</span>`,
            lat: val.lat,
            lng: val.lng,
          }];
        this.mapObj.addMarkers(marker);
        this.mapObj.focus({
          lat: val.lat,
          lng: val.lng,
          zoom: 14
        });
        this.mapObj.clusterSynch();
      }
      if (this.checkTimestamp(val.gpsTS)) {
        const results = await this.getNearestEmpVeh({ lat: val.lat, lng: val.lng });
        this.nearestEmployees = results[0];
        this.nearestVehicles = results[1];
        let arr = [];
        if (this.nearestVehicles && this.nearestVehicles.length > 0) {
          const currnentTMS = new Date().getTime();
          this.nearestVehicles.filter(async (item: any) => {
            if (item != undefined && item.gpsts != undefined) {
              const timeDiff = this.comService.timeDiff((String(item.gpsts).length > 10 ? item.gpsts : item.gpsts * 1000), currnentTMS);
              if (timeDiff.hh <= 2) {
                if ((timeDiff.hh < 2 && timeDiff.mm <= 59) || (timeDiff.hh == 2 && timeDiff.mm == 0)) {
                  arr.push(item);
                }
              }
            }
          });
          this.nearestVehicles = arr;
        }
        if (this.nearestVehicles.length <= 0) {
          this.showNoVeh = true;
        } else {
          this.showNoVeh = false;
        }
        if (this.nearestEmployees.length <= 0) {
          this.showNoEmp = true;
        } else {
          this.showNoEmp = false;
        }
        this.setNearByEmpMarkers(this.nearestEmployees);
        this.setNearByVehMarkers(this.nearestVehicles);
      }
      this.isShowEmployeeData = true;
      if (this.isShowNearby) document.getElementById('profile-tab').click();
      this.loader.hide();
    }
  }

  setNearByEmpMarkers(employees) {
    const marker = [];
    this.nearByEmpMarkers = [];
    if (employees.length > 0) {
      if (this.selectedMap == 'google') {
        if (this.nearByEmpMarkers.length > 0) {
          for (let i = 0; i < this.nearByEmpMarkers.length; i++) {
            this.nearByEmpMarkers[i].setMap(null);
          }
        }
        let infoWindowContent;
        let infowindow = [];
        for (let i = 0; i < employees.length; i++) {
          let loc = {
            lat: +employees[i].location.lat,
            lng: +employees[i].location.lng,
          }
          var image = {
            origin: new google.maps.Point(0, 0),
            url: "assets/images/map/googleMap/green-black-emp.png",
            scaledSize: new google.maps.Size(24, 36),
          };
          this.nearByEmpMarkers.push(new google.maps.Marker({
            position: loc,
            map: this.googleMapObj,
            icon: image
          }));
          infoWindowContent = '<div class="window-content-container"><span style="font-weight:700">' + this.comService.convertTitleCase(employees[i].name) + '</span><div style="margin-top:2px">' + 'Emp ID :' + '<span>' + ' ' + employees[i].empRefID + '</span></div><div style="margin-top:2px">' + 'Mobile :' + ' ' + '<span>' + employees[i].mobile + '</span>' + '</div>' + '</div>';
          infowindow.push(new google.maps.InfoWindow({
            content: infoWindowContent
          }));
          for (let j = 0; j < this.nearByEmpMarkers.length; j++) {
            this.nearByEmpMarkers[j].addListener('click', (e) => {
              this.googleMapObj.setZoom(15);
              this.googleMapObj.panTo(this.nearByEmpMarkers[j].position);
            })
            google.maps.event.addListener(this.nearByEmpMarkers[j], 'click', function () {
              if (infowindow[j]) {
                infowindow[j].close();
              }
              infowindow[j].open(this.googleMapObj, this);
            });
          }
        }
        if (this.singleViewCluster) {
          this.singleViewCluster.clearMarkers();
        }
        this.singleViewCluster = new MarkerClusterer(
          this.googleMapObj, this.nearByEmpMarkers, this.clusteringOptions
        );
      } else {
        for (let e = 0; e < employees.length; e++) {
          let markerObj = {
            id: employees[e].employeeID,
            content: '<img src="../../../assets/images/map/person.png" style="height: 50px;width: 50px;position: relative;top: 4px;left: -6px;">',
            lat: employees[e].location.lat,
            lng: employees[e].location.lng,
            popup: {
              content: `<p class="mb-1">${employees[e].name}</p>`,
              open: false
            },
            cluster: 'SOSEmployeecluster',
          };
          this.nearByEmpMarkers.push(markerObj);
          marker.push(markerObj);
        }
        this.mapObj.addMarkers(marker);
        this.mapObj.clusterSynch();
      }
    }
  }

  async setNearByVehMarkers(vehicles) {

    if (vehicles.length > 0) {
      this.noDataEnable = false;
      let vehArr = [];
      for (let i = 0; i < vehicles.length; i++) {
        vehArr.push(vehicles[i].reg)
      }
      let nerbyVehObj = {};
      for (let j = 0; j < vehArr.length; j++) {
        nerbyVehObj[vehArr[j]] = {
          'regNo': vehArr[j]
        }
      }

      let obj = {
        vendorID: this.vendorID
      }

      await this.api.transportManagerAssignedVehDriverListHl(obj).then((res: any) => {
        if (res.status == 'success') {
          if (res.data.length > 0) {
            let drivers = res.data;
            for (let k = 0; k < drivers.length; k++) {
              for (let l = 0; l < vehArr.length; l++) {
                if (drivers[k].vehRegNo == nerbyVehObj[vehArr[l]]['regNo']) {
                  nerbyVehObj[vehArr[l]]['driverID'] = drivers[k]['driverID'];
                }
              }

            }
          }
        }
      })

      this.api.transportManagerDriverListHl(obj).then((res: any) => {
        if (res.status == 'success') {
          if (res.data.length > 0) {
            let driversArr = res.data;
            for (let i = 0; i < driversArr.length; i++) {
              for (let j = 0; j < vehArr.length; j++) {
                if (driversArr[i].driverID == nerbyVehObj[vehArr[j]].driverID) {
                  nerbyVehObj[vehArr[j]]['driverName'] = driversArr[i].name;
                  nerbyVehObj[vehArr[j]]['driverNo'] = driversArr[i].mobile;
                }
              }
            }
            this.nearByVehicles = nerbyVehObj;
          }
        }
      });
    }
    else {
      this.noDataEnable = true;
    }
    const marker = [];
    this.nearByVehMarkers = [];
    if (vehicles.length > 0) {
      if (this.selectedMap == 'google') {
        if (this.nearByVehMarkers.length > 0) {
          for (let i = 0; i < this.nearByVehMarkers.length; i++) {
            this.nearByVehMarkers[i].setMap(null);
          }
        }
        let infoWindowContent;
        let infowindow = [];
        for (let i = 0; i < vehicles.length; i++) {
          let loc = {
            lat: +vehicles[i].lat,
            lng: +vehicles[i].lng,
          }
          var image = {
            origin: new google.maps.Point(0, 0),
            url: "assets/images/map/googleMap/green-black-veh.png",
            scaledSize: new google.maps.Size(24, 36),
          };
          this.nearByVehMarkers.push(new google.maps.Marker({
            position: loc,
            map: this.googleMapObj,
            icon: image
          }));
          infoWindowContent = '<div class="window-content-container"><span style="font-weight:700">' + vehicles[i].reg + '</span><div style="margin-top:2px">' + 'Updated :' + '<span>' + ' ' + this.comService.timestampToDate(vehicles[i].gpsts * 1000) + '</span></div><div style="margin-top:2px">' + 'Speed :' + ' ' + '<span>' + vehicles[i].spd + ' ' + 'kmph' + '</span>' + '</div>' + '</div>';
          infowindow.push(new google.maps.InfoWindow({
            content: infoWindowContent
          }));
          for (let j = 0; j < this.nearByVehMarkers.length; j++) {
            this.nearByVehMarkers[j].addListener('click', (e) => {
              this.googleMapObj.setZoom(15);
              this.googleMapObj.panTo(this.nearByVehMarkers[j].position);
            });
            google.maps.event.addListener(this.nearByVehMarkers[j], 'click', function () {
              if (infowindow[j]) {
                infowindow[j].close();
              }
              infowindow[j].open(this.googleMapObj, this);
            });
          }
        }
      } else {
        for (let e = 0; e < vehicles.length; e++) {
          let markerObj = {
            id: vehicles[e].reg,
            content: '<img src="../../../assets/images/dashboard/vehicle-marker.png" style="height: 40px;width: 28px;position: relative;top: 4px;left: -6px;">',
            lat: vehicles[e].lat,
            lng: vehicles[e].lng,
            popup: {
              content: `<p class="mb-1"><b>${vehicles[e].reg.toUpperCase()}</b></p>`,
              open: false
            },
            cluster: 'SOSVehiclecluster',
          };
          this.nearByVehMarkers.push(markerObj);
          marker.push(markerObj);
        }
        this.mapObj.addMarkers(marker);
        this.mapObj.clusterSynch();
      }

    }
  }



  playMultiAudio(audio) {
    let audioEl: any = document.getElementById('audioSrc');
    let index = 1;
    audioEl.onended = function () {
      if (index < audio.length) {
        audioEl.src = audio[index];
        audioEl.play();
        index++;
      }
    };
  }

  close() {
    this.audioisShow = false;
    this.isShowNearby = false;
    this.isShowEmployee = false;
    this.isShowVehicle = false;
    this.mapHight = '82.5vh';
    this.notificationHeight = '75.85vh';
    this.initMap([]);
    setTimeout(() => {
      this.setMarkers();
    }, 1000)
  }

  openTakeAction() {
    this.closeTakeAction = false;
  }

  reloadSosData(value) {
    this.audioisShow = false;
    this.isShowNearby = false;
    this.isShowEmployee = false;
    this.isShowVehicle = false;
    this.noDataEnable = false;
    this.mapHight = '82.5vh';
    this.notificationHeight = '75.85vh';
    this.getSOSReports();
  }

  async filterData(reportData) {
    let allVehicle = [];
    let sosvehicle: any;
    const currnentTMS = new Date().getTime();
    const restrictedDays = new Date().setDate(new Date().getDate());
    const restrictedDatetime = new Date(restrictedDays).setHours(0, 0, 0, 0);
    const restrictedTimestamp = new Date(restrictedDatetime).getTime();
    reportData.filter(async (item: any) => {
      if (item != undefined && item.gpsTS != undefined) {
        const timeDiff = this.comService.timeDiff((String(item.gpsTS).length > 10 ? item.gpsTS : item.gpsTS * 1000), currnentTMS);
        if (timeDiff.hh <= 4) {

          if (timeDiff.hh < 4) {
            allVehicle.push(item);
          }
          else if (timeDiff.hh == 4 && timeDiff.mm == 0) {
            allVehicle.push(item);
          }
        }
      }
    });
    this.notificationData = allVehicle;
  }
}
